module.exports = __webpack_public_path__ + "img/atend.99f3a612.svg";